'use client';

import React from 'react';
import { type BuyerLayoutProps } from 'shop-ui/types';
import { replacePlaceholder } from 'libs/replacePlaceholder';

interface ProductPromoInfoProps extends BuyerLayoutProps<Product> {}

export const ProductPromoInfo: React.FC<ProductPromoInfoProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const { promos } = product;

    return (
        <ul>
            {promos.map((promo, idx) => {
                return (
                    <div key={promo.id + promo.type + idx}>
                        <li className="skeleton skeleton--ssr skeleton--xs">
                            <p className="ssr-hidden">
                                {promo.is_display_name && promo.name + ' '}
                                {replacePlaceholder(
                                    promo.promotional_copy.text,
                                    promo.promotional_copy.placeholder,
                                    'inherit'
                                )}
                            </p>
                        </li>
                        <div className="skeleton-spacer"></div>
                    </div>
                );
            })}
        </ul>
    );
};
